import { Flex, Text, Button } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';

export default function UserMenu() {
  const { user, authStatus, signOut } = useAuthenticator((ctx) => [
    ctx.user,
    ctx.authStatus
  ]);

  if (authStatus !== "authenticated" || !user) return null;

  const login = user?.signInDetails?.loginId ?? user?.username ?? "Account";

  return (
    <Flex alignItems="center" gap="0.75rem">
      <Text
        fontSize="small"
        color="font.secondary"
        title={login}
        maxWidth={{ base: "10rem", medium: "18rem" }}
        isTruncated
      >
        {login}
      </Text>

      <Button
        size="small"
        variation="link"
        onClick={signOut}
        ariaLabel="Sign out"
      >
        Sign out
      </Button>
    </Flex>
  );
}